import { ESC_KEY_CODE as r } from "./index.es741.js";
import { baseOnKeyDown as m } from "./index.es742.js";
const E = (o, e, n = !1) => m(o, r, e, n);
export {
  E as onKeyDownEsc
};
//# sourceMappingURL=index.es528.js.map
